import AddAPhotoRoundedIcon from "@mui/icons-material/AddAPhotoRounded";
import { Box, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";

import { ModalOrDrawerContainer } from "../ModalOrDrawerContainer/ModalOrDrawerContainer";
import { PhotoEditMain } from "../photo-edit-main";
import Typography from "../Typography";
import ImageSuggestion from "./ImageSuggestion";
import { PhotoUploadModalProps } from "./photo-upload-modal.interface";
import * as styles from "./photo-upload-modal.styles";

export const PhotoUploadModal = ({
  open,
  handleClose,
  defaultPhotoSearchQuery,
  image,
  ...props
}: PhotoUploadModalProps) => {
  const [selectedImage, setSelectedImage] = useState<string | undefined | File>(
    image
  );
  useEffect(() => {
    setSelectedImage(image);
  }, [image]);
  const scrollComponent = useRef<HTMLDivElement>();
  const scrollToUp = () => {
    if (scrollComponent.current) {
      scrollComponent.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  const handleChoose = (url: string) => {
    setSelectedImage(url);
    scrollToUp();
  };
  const handleImageLoad = async (event: React.BaseSyntheticEvent) => {
    if (event.target.files[0]) {
      setSelectedImage(event.target.files[0]);
    }
  };

  return (
    <ModalOrDrawerContainer
      open={open}
      handleClose={handleClose}
      title="Photo upload"
    >
      <Box sx={styles.root}>
        <Box ref={scrollComponent} />
        {selectedImage && (
          <>
            <Typography
              variant="body2"
              sx={{
                mt: { xs: 0, md: 1 },
                mb: { xs: 1, md: 0 },
                textAlign: "center",
              }}
            >
              Photo edit
            </Typography>
            <PhotoEditMain
              sx={{ mb: 3 }}
              handleClose={() => {
                setSelectedImage(undefined);
                handleClose();
              }}
              {...props}
              image={selectedImage}
            />
          </>
        )}
        {defaultPhotoSearchQuery ? (
          <>
            <ImageSuggestion
              handleChoose={handleChoose}
              defaultSearchQuery={defaultPhotoSearchQuery}
            />
            <Typography
              variant="body2"
              sx={{
                marginTop: 1,
                textAlign: "center",
              }}
            >
              Or
            </Typography>
          </>
        ) : (
          <></>
        )}
        <Typography
          variant="body2"
          sx={{
            marginTop: 1,
            textAlign: defaultPhotoSearchQuery ? "left" : "center",
          }}
        >
          Add your custom photo
        </Typography>
        <Box sx={styles.addImageButtonContainer}>
          <IconButton sx={styles.addImageIconButton} component="label">
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={handleImageLoad}
            />
            <AddAPhotoRoundedIcon sx={styles.addImageIcon} />
          </IconButton>
          <Typography variant="body2">Add a photo</Typography>
        </Box>
      </Box>
    </ModalOrDrawerContainer>
  );
};
